import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SMALL_SCREEN_WIDTH } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ScreenDimensionsService {
  private screenWidth = new BehaviorSubject<number>(window.innerWidth);
  private screenHeight = new BehaviorSubject<number>(window.innerHeight);
  private isSmallScreen = new BehaviorSubject<boolean>(window.innerWidth <= SMALL_SCREEN_WIDTH);

  screenWidth$ = this.screenWidth.asObservable();
  screenHeight$ = this.screenHeight.asObservable();
  isSmallScreen$ = this.isSmallScreen.asObservable();

  constructor() {
    this.updateScreenDimensions();
    window.addEventListener('resize', this.updateScreenDimensions.bind(this));
  }

  private updateScreenDimensions(): void {
    const width = window.innerWidth;
    const height = window.innerHeight;
    this.screenWidth.next(width);
    this.screenHeight.next(height);
    this.isSmallScreen.next(width <= SMALL_SCREEN_WIDTH);
  }
}